import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import '@/assets/css/scrollbar.css';
	import { ref, onMounted, watch } from 'vue';
	import axios from 'axios';
	import { FieldSchema } from '@/models/form';
	import { School } from '@/models/loans';
	import BaseFormField from '@/components/form-fields/BaseFormField.vue';

	
export default /*@__PURE__*/_defineComponent({
  __name: 'SchoolSearchSelect',
  props: {
    disabled: { type: Boolean },
    initialSchool: {},
    programTypeId: {},
    productTypeId: {},
    lenderId: {}
  },
  emits: ['update:selectedSchool'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

	const props = __props;

	const schoolSelectSchema: FieldSchema = {
		name: 'school',
		type: 'autocomplete',
		autocompleteProperty: 'schoolName',
		autoCompleteResultsErrorMessage: 'No matches found',
		hideLabel: false,
		label: 'School',
		placeholder: 'Search...',
		required: false
	};

	const selectedSchool = ref({} as School);
	const filteredSchools = ref<School[]>([]);
	const formFieldComponentRef = ref<InstanceType<typeof BaseFormField> | null>(null);

	const emit = __emit;
	
	watch(selectedSchool, (newValue) => {
		emit('update:selectedSchool', newValue);
	});

	function selectSchool(school: School) {
		selectedSchool.value = school;

		if (formFieldComponentRef.value) {
			const validSchoolSelection =
				selectedSchool.value &&
				Object.keys(selectedSchool.value).includes("schoolDOEId") &&
				Object.keys(selectedSchool.value).includes("schoolBranchDOEId");

			if (validSchoolSelection) {
				formFieldComponentRef.value?.autocompleteInputRef?.setAttribute(
					"title",
					`${school.schoolDOEId}-${school.schoolBranchDOEId}`
				);
			} else {
				formFieldComponentRef.value?.autocompleteInputRef?.removeAttribute("title");
			}
		}
	}

	function findSchool(schoolCode: string, schoolBranch: string) {
		return filteredSchools.value.find((s: School) => s.schoolDOEId === schoolCode && s.schoolBranchDOEId === schoolBranch);
	}

	function findSchoolWithDetailId(schoolDetailsId: number) {
		return filteredSchools.value.find((s: School) => s.schoolDetailsId == schoolDetailsId);
	}
	
	function discardChanges(initialValue: School) {
		const matchingSchool = filteredSchools.value.find((school) => {
			const matchingCode = school.schoolDOEId === initialValue?.schoolDOEId;
			const matchingBranch = school.schoolBranchDOEId === initialValue?.schoolBranchDOEId;

			return matchingCode && matchingBranch;
		});

		if (matchingSchool) {
			selectSchool(matchingSchool);
		}
	}

	async function getSchoolsAsync() {
		try {
			const response = await axios.get('/api/schools', {
				params: {
					programTypeId: props.programTypeId,
					productTypeId: props.productTypeId,
					lenderId: props.lenderId
				}
			});

			filteredSchools.value = response.data;

			if (props.initialSchool) {
				const matchingSchool =
					(props.initialSchool.schoolDetailsId
						? filteredSchools.value.find((school) => school.schoolDetailsId == props.initialSchool?.schoolDetailsId)
						: undefined)
					?? filteredSchools.value.find((school) =>
						school.schoolDOEId === props.initialSchool?.schoolDOEId
						&& school.schoolBranchDOEId === props.initialSchool?.schoolBranchDOEId);

				if (matchingSchool) {
					selectSchool(matchingSchool);
				}
			}
		} catch (error) {
			console.error('Failed to get schools:', error);
		}
	}

	onMounted(async () => {
		await getSchoolsAsync();
	});

	__expose({
		filteredSchools,
		selectedSchool,
		findSchool,
		findSchoolWithDetailId,
		discardChanges
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseFormField, {
    ref_key: "formFieldComponentRef",
    ref: formFieldComponentRef,
    class: "base-form-field",
    disabled: __props.disabled,
    modelValue: selectedSchool.value,
    "onUpdate:modelValue": [
      _cache[0] || (_cache[0] = ($event: any) => ((selectedSchool).value = $event)),
      selectSchool
    ],
    schema: schoolSelectSchema,
    autocompleteOptions: filteredSchools.value
  }, null, 8, ["disabled", "modelValue", "autocompleteOptions"]))
}
}

})